export default{
    Datis(data){
        var transformedData = {
                type: "FeatureCollection",
                features: []
            },
            itemData = {};

        data = data.reverse()

        for(var i=0; i< data.length;i++) {
            itemData = data[i];

            if(itemData.dati) {
                if (data[i].alerts && data[i].alerts.length > 0) {
                    itemData.spClass = "alert-animate";
                } else if (data[i].lost_com_at != null) {
                    itemData.spClass = "alert-lostcom";
                } else {
                    itemData.spClass = "";
                }

                if ((itemData.gps_y != 0 && itemData.gps_y != null) || (itemData.gps_x != 0 && itemData.gps_x != null)) {

                    transformedData.features.push({
                        "geometry": {
                            "coordinates": [itemData.gps_y, itemData.gps_x],
                            "type": "Point"
                        },
                        "type": "Feature",
                        "properties": itemData
                    })
                }
            }
        }
        return transformedData;
    }
}
